<template>
  <el-checkbox-group
    class="base-checkbox-group"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'BaseCheckboxGroup2'
}
</script>

<style lang="scss" scoped>

$--radio-font-size: 14px;
$--radio-padding: 8px 15px;
$--radio-border-color: #E1E1E1;

.base-checkbox-group ::v-deep {
  .el-checkbox.is-bordered {
    // 基本
    margin-right: 0;
    border-color: $--radio-border-color;
    border-radius: $--border-radius-base2;
    & +.el-checkbox.is-bordered {
      margin-left: 10px;
    }

    .el-checkbox__input {
      .el-checkbox__inner {
        width: 14px;
        height: 14px;
        border-color: $--radio-border-color;
        &:hover {
          border-color: $--radio-border-color !important;
        }
        &::after {
          height: 7px;
          width: 3px;
        }
      }
      &.is-focus .el-checkbox__inner {
        border-color: $--radio-checked-border-color !important;
      }
    }
    .el-checkbox__label {
      padding-left: 5px;
      font-size: $--radio-font-size;
    }

    // hover
    &:hover {
      color: $--radio-hover-font-color;
      border-color: $--radio-hover-border-color;
    }
    // 选中
    &.is-checked {
      // position: relative;
      color: $--radio-checked-font-color;
      border-color: $--radio-checked-border-color;
      background: $--radio-checked-background-color;
      box-shadow: none;
      .el-checkbox__inner {
        border-color: $--radio-checked-border-color !important;
        background-color: $--radio-checked-font-color !important;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label {
        color: $--radio-checked-font-color;
      }
      // &::after {
      //   content: '';
      //   position: absolute;
      //   right: 0;
      //   bottom: 0;
      //   display: block;
      //   width: 14px;
      //   height: 13px;
      //   background: url(~@@/assets/img/icons/icon_radio2.png);
      // }
    }
  }

  .hide-checkbox {
    // 隐藏复选框
    .el-checkbox__input {
      display: none;
    }
    // 选中
    &.is-checked {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        right: -1px;
        bottom: -1px;
        display: block;
        width: 14px;
        height: 13px;
        background: url(~@@/assets/img/icons/icon_radio2.png);
      }
    }
  }
}
</style>
